import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dateToString } from '@/util/date';
import { ScheduleService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const usePublishMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (date: Date) => {
      return ScheduleService.scheduleServicePublishSchedule({
        query: {
          toDate: dateToString(date),
        },
      });
    },
    onSettled: async (data, _error, _variables) => {
      // If we have response data, use the server's date, otherwise fallback to input date
      const publishedDate = data?.data?.date
        ? new Date(data.data.date)
        : _variables;
      const year = publishedDate.getFullYear();
      const month = publishedDate.getMonth() + 1;

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.schedule.publishDate(year, month),
        }),
      ]);
    },
  });
};
